import React, { useState } from 'react';
import { Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import * as XLSX from 'xlsx';
import PopoverFiltroRelatorio from './PopoverFiltroRelatorio';

export default function RelatorioData({ data, campos, type, filtro, setFiltro, onLimpar }) {
  const [openFiltro, setOpenFiltro] = useState(null);

  const onCloseFiltro = () => {
    setOpenFiltro(null);
  };

  const limparFiltro = () => {
    setOpenFiltro(false);
    onLimpar();
  };

  const onConfirmFiltro = (filtro) => {
    setOpenFiltro(false);
    setFiltro(filtro);
  };

  const exportToExcel = () => {
    const formattedData = data.map((row) => {
      const newRow = {};
      campos.forEach((key) => {
        newRow[key] = row[key];
      });
      return newRow;
    });

    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Relatorio');
    XLSX.writeFile(wb, `${type}_relatorio.xlsx`);
  };

  return (
    <Stack spacing={2} sx={{ mt: 5 }}>
      <Stack direction="row" spacing={2} ml={'auto'}>
        <Button variant="outlined" onClick={(e) => setOpenFiltro(true)}>
          Filtro
        </Button>
        <Button variant="contained" onClick={exportToExcel}>
          Download Excel
        </Button>
      </Stack>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {campos.map((key) => (
                <TableCell key={key}>{key}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                {campos.map((key, idx) => (
                  <TableCell key={idx}>{String(row[key])}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {openFiltro && (
        <PopoverFiltroRelatorio
          filtro={filtro}
          open={openFiltro}
          onClose={onCloseFiltro}
          onLimpar={limparFiltro}
          onConfirm={onConfirmFiltro}
          type={type}
        />
      )}
    </Stack>
  );
}
